import { ContextMenu } from "lib/@components/context-menu-bar"

export const LegislationLibraryItemContextMenu = ContextMenu("legislation-library-item")
